const parseObjectToSeo = (data) => {
  return {
    title: data?.metatitle || null,
    description: data?.metadescription || null,
  };
};

export default parseObjectToSeo;
